
import React from 'react';
import BaseComponent from './Base';
import { Link } from 'react-router-dom';

//کامپوننت تیکتها
class Tickets extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : "tickets",
        filterParams:[]
      };

      super(props, config);
    }
    componentWillReceiveProps(props){
      this.state.data = null;
      this.refresh();
    }
    renderListView(){
      return (
        <div>
          <div className="row" style={{"marginBottom":"19px"}}>
            <div className="col-md-12 col-sm-12 col-xs-12">
              <Link to="/tickets/new/" className="btn btn-success">
                <i className="fa fa-plus"></i>
                ارسال پیام جدید
              </Link>
            </div>
          </div>
          {this.state.data.records.length > 0 ?
            <div className="row">
              {this.state.data.records.map(_t=>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className={_t.ticket_status === 1 ? "box box-warning" : _t.ticket_status === 2 ? "box box-success" : _t.ticket_status === 2 ? "box box-info" : "box box-danger"}>
                    <div className="box-header with-border">
                      <h3 className="box-title" style={{"display":"block"}}>
                        {this.enumString(_t.ticket_status,"ticket_status")}
                        <span className="label label-info pull-left"><i className="fal fa-clock"></i> {this.g2j(_t.edit_date,6)}</span>
                      </h3>
                    </div>
                    <div className="box-body">
                      <ul className="products-list product-list-in-box">
                        <div className="item">
                          <p className="message">
                            متن پیام:
                            <Link to={"/tickets/view/" + _t.id} className="name">
                              <p className="message" dangerouslySetInnerHTML={{__html: _t.Details[0].content}}></p>                              
                            </Link>
                          </p>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          :
            <h4 className="alert alert-info text-center">کاربر گرامی صندوق پیام های ارسالی و دریافتی شما خالی می باشد</h4>
          }
        </div>
      );
    }
    render() {
      if (this.state.data === null || this.state.data === undefined)
        return this.showLoading();
      if (this.state.data.status === 500 || this.state.data.status === 0)
        return this.render500()
      if (this.state.data.status === 404)
        return this.render404()
      if (this.state.data.status === 2)
        return this.renderNoAccess();
      if (this.state.data.status === 4)
        return this.renderNoLogin();
      return this.renderListView();
    }
  }
  export default Tickets;